"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_vodafone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "8fb37752-138b-44b0-887e-0c39b754f0da",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160.23 160"
  }, props), /*#__PURE__*/React.createElement("title", null, "market_icn_Vodafone_store"), /*#__PURE__*/React.createElement("path", {
    id: "a3d43f30-20ff-4809-b4ce-d314577a0a8f",
    "data-name": "<Pfad>",
    d: "M145.6,69.12A14.63,14.63,0,0,0,158,76c8.09,0,14.16-6.56,14.16-14.66V58.1l-3.74-30.7a8.73,8.73,0,0,0-8.63-7.4H32.21a8.73,8.73,0,0,0-8.63,7.4L19.95,58.1l0,3.23C19.93,69.43,25.89,76,34,76a14.63,14.63,0,0,0,12.4-6.87",
    transform: "translate(-15.93 -16)",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.39,69.12a14.63,14.63,0,0,0,24.8,0",
    transform: "translate(-15.93 -16)",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.19,69.12a14.63,14.63,0,0,0,24.8,0",
    transform: "translate(-15.93 -16)",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,69.12a14.63,14.63,0,0,0,24.8,0",
    transform: "translate(-15.93 -16)",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.79,69.12a14.63,14.63,0,0,0,24.8,0",
    transform: "translate(-15.93 -16)",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.74,
    y1: 36,
    x2: 155.48,
    y2: 36,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.07,
    y: 84,
    width: 44,
    height: 72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.07,
    y: 84,
    width: 44,
    height: 72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.07 58.67 12.07 156 148.07 156 148.07 58.67",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = ic_vodafone;
exports.default = _default;